import React, { useState, useEffect, useCallback } from "react";
import { Row, Col, Button, Image, Container } from "react-bootstrap";
import Rating from "@mui/material/Rating";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import axios from "axios";
import { base_url, ImageUrl, postHeader } from "../../../../../Helpers/request";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Heading from "../ui/Heading";
import { isDesktop, isMobile } from "react-device-detect";

const Customer = () => {
  const [customerData, setCustomerData] = useState([]);

  const GetCustomerRewies = useCallback(() => {
    axios
      .get(`${base_url}/common/site_reviews`, { headers: postHeader })
      .then(({ data }) => {
        if (data.status === 1) {
          setCustomerData(data.data);
        }
      })
      .catch((error) => console.error("Error fetching reviews:", error));
  }, []);

  useEffect(() => {
    GetCustomerRewies();
  }, [GetCustomerRewies]);

  const settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: <LazyLoadImage src={`${ImageUrl}theme/showcase/left.png`} alt="" />,
    nextArrow: <LazyLoadImage src={`${ImageUrl}theme/showcase/right.png`} alt="" />,
    responsive: [
      { breakpoint: 1479, settings: { slidesToShow: 4, dots: true, arrows: false } },
      { breakpoint: 1025, settings: { slidesToShow: 2, dots: true, arrows: false } },
      { breakpoint: 600, settings: { slidesToShow: 1, dots: true, arrows: false } },
    ],
  };

  return (
    <section className="rcs_customer_say_section">
      <Container fluid className="showcase-container">
        <div className="d-flex align-items-center justify-content-between pb-3">
          <Heading className="text-left p-0">
            <h2>Happy Customers</h2>
            <p>Words of Praise</p>
          </Heading>
          {isDesktop && (
            <div className="rcs_customer_review_btn">
              <Button className="btn outline-base-btn large" onClick={() => window.open(customerData?.google_review_url, "_blank")}>
                Write a Review
              </Button>
            </div>
          )}
        </div>

        <Row>
          <Col lg={12} data-aos="fade-up" data-aos-duration="1400">
            <div className="rcs_customer_review_slider">
              <Slider className="rcs_customer_say_inner" {...settings2}>
                {customerData.map((customdata, index) => (
                  <div className="rcs_customer_review_slide_item" key={index}>
                    <div className="rcs_customer_slide_title_img mb-4">
                      <div className="rcs_customer_review_slide_img">
                        <LazyLoadImage
                          src={`${ImageUrl}theme/showcase/review.png`}
                          alt="Google Review Image"
                          onClick={() => window.open(customdata?.review_url, "_blank")}
                        />
                      </div>
                    </div>
                    <div className="rcs_customer_slide_text_content mb-4">
                      <p>{customdata?.review?.slice(0, 150)}{customdata?.review?.length > 150 ? "..." : ""}</p>
                      <Link to="#" onClick={() => window.open(customdata?.review_url, "_blank")}>
                        Read More
                      </Link>
                    </div>
                    <div className="rcs_customer_review_footer d-flex align-items-center">
                      <div className="name-charAt mr-3">{customdata?.username?.charAt(0)}</div>
                      <div className="rcs_customer_review_slide_title">
                        <h3>{customdata?.username}</h3>
                        <Rating name="half-rating-read" value={customdata?.rating || 5} precision={0.5} size="medium" readOnly />
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
        </Row>

        {isMobile && (
          <div className="rcs_customer_review_btn text-center mt-5">
            <Button className="btn outline-base-btn large" onClick={() => window.open(customerData?.google_review_url, "_blank")}>
              Write a Review
            </Button>
          </div>
        )}
      </Container>
    </section>
  );
};

export default Customer;
